<div
    data-testid="details-header-checkbox-urgent"
    [attr.data-urgent]="internalUrgent()"
    [attr.data-disabled]="disabled()"
    class="w-6 h-6 cursor-pointer"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="toggleUrgent()"
>
    <img
        [src]="'assets/icons/bookmark/' + icon() + '.svg'"
        [class.opacity-90]="!hovered() && !internalUrgent()"
        [style.filter]="
            internalUrgent()
                ? 'brightness(0) saturate(100%) invert(27%) sepia(90%) saturate(700%) hue-rotate(330deg)'
                : 'var(--urgent-button-default-filter)'
        "
        class="w-6 h-6 [--urgent-button-default-filter:brightness(0)_invert(0.35)] [html[theme='dark']_&]:[--urgent-button-default-filter:brightness(0)_invert(1)]"
        alt=""
    />
</div>
